class MenubarNavigation {
	constructor(domNode) {
		this.HTMLBody = document.body;
		this.component = domNode; // #top-menu
		this.mobileWrapper = domNode.querySelector(".menu");
		this.mobileOverlay = domNode.querySelector(".overlay");
		this.mobileHomeLink = domNode.querySelector(".brand-mobile-submenu");
		this.menuTitleEl = domNode.querySelector(".menu-mobile-title");
		this.toggleButton = domNode.querySelector("#mobileMenuToggle");
		this.closeButton = domNode.querySelector("button.menu-mobile-close");
		this.backButton = domNode.querySelector("button.menu-mobile-back");
		this.menu = domNode.querySelector("nav > ul");

		this.isMobile = false;
		this.menuItems = []; // All menuitems available <a/>
		this.availableItems = []; // Current list of tabAble items <a/>

		this.submenuItems = []; // All items with submenu available <a/>
		this.submenuSelected = null; // Current selected submenu <a/>

		this.selectedItem = null;
		this.selectedId = null;
	}

	resetTabindex() {
		this.menuItems.forEach((_, index) => {
			this.menuItems[index].tabIndex = -1;
		});
	}

	tabIndexFirstAvailable() {
		// Some links are available only to mobile
		const firstVisible = this.availableItems.findIndex((item) => !MenubarNavigation.isHidden(item));
		if (!firstVisible) return;
		this.availableItems[firstVisible].tabIndex = 0;
		this.selectedItem = this.availableItems[firstVisible];
		this.selectedId = firstVisible;
	}

	closeAllSubmenus() {
		this.submenuItems.forEach((item) => {
			item.setAttribute("aria-expanded", false);
			item.nextSibling.classList.remove("active");
			this.backButton.classList.add("hide");
			this.mobileHomeLink.classList.remove("hide");
			this.menuTitleEl.innerText = "";
		});
	}

	menuToggle() {
		this.closeAllSubmenus();
		if (this.currentItemHasPopup()) {
			this.menuTitleEl.innerText = this.selectedItem.innerText;
			this.backButton.classList.remove("hide");
			this.mobileHomeLink.classList.add("hide");
			this.selectedItem.setAttribute("aria-expanded", true);
			this.selectedItem.nextSibling.classList.add("active");
			return true;
		}
		return false;
	}

	menuSelect() {
		if (this.currentItemHasPopup()) {
			const list = this.selectedItem.parentNode.querySelector("ul");
			this.submenuSelected = this.selectedItem;
			this.getAvailableItems(list);
			this.selectItem(0);
		} else if (this.submenuSelected) {
			// back to parent menu
			const list = this.submenuSelected.closest("ul");
			this.getAvailableItems(list);
			this.selectItem(this.submenuSelected);
			this.submenuSelected = null;
		}
	}

	// Roving tabindex
	selectItem(value) {
		this.resetTabindex();

		const firstVisible = this.availableItems.findIndex((item) => !MenubarNavigation.isHidden(item));

		let itemId = 0;

		if (Number.isInteger(value)) {
			itemId = value;
		} else {
			itemId = this.availableItems.findIndex((cItem) => cItem.isEqualNode(value));
			itemId = itemId >= 0 ? itemId : 0;
		}

		// rolling into items
		if (itemId >= this.availableItems.length) {
			itemId = firstVisible; // Back to start
		} else if (itemId < firstVisible) {
			itemId = this.availableItems.length - 1; // Go to end
		}
		this.selectedId = itemId;
		this.selectedItem = this.availableItems[itemId];
		this.selectedItem.tabIndex = 0;
		this.selectedItem.focus();
		// this.menuToggle();
	}

	getAvailableItems(list) {
		this.resetTabindex();
		const items = [];

		let el = list.firstElementChild;
		while (el) {
			const link = el.querySelector('[role="menuitem"]');
			if (link) items.push(link);
			el = el.nextElementSibling;
		}

		this.availableItems = items;
	}

	currentItemHasPopup(item = false) {
		if (item) {
			return item.getAttribute("aria-hasPopup") === "true";
		}
		return this.selectedItem.getAttribute("aria-hasPopup") === "true";
	}

	setInitialstate() {
		this.closeAllSubmenus();
		this.getAvailableItems(this.menu);
		this.tabIndexFirstAvailable();
		if (this.isMobile) {
			this.mobileToggle();
		}
	}

	onKeydown(event) {
		const { key } = event;
		let preventDefault = false;
		switch (key) {
			case " ":
			case "Enter":
				if (this.currentItemHasPopup()) {
					this.menuToggle();
					this.menuSelect();
					preventDefault = true;
				}
				break;
			case "Esc":
			case "Escape":
				if (this.submenuSelected) {
					this.menuToggle(); // if submenu open, close
					this.menuSelect(); // then select parent menu
				} else if (this.isMobile) {
					this.mobileToggle(); // if all submenu closed and isMobile, close menu
				}
				break;
			case "Up":
			case "ArrowUp":
				if (this.submenuSelected || this.isMobile) {
					this.selectItem(this.selectedId - 1);
				}
				preventDefault = true;
				break;

			case "ArrowDown":
			case "Down":
				if (this.submenuSelected || this.isMobile) {
					this.selectItem(this.selectedId + 1);
				} else if (!this.isMobile) {
					this.menuSelect();
				}
				preventDefault = true;
				break;

			case "Left":
			case "ArrowLeft":
				if (this.isMobile) {
					if (this.submenuSelected) {
						this.menuToggle(); // if has submenu, close
						this.menuSelect(); // then select first item
					}
				} else if (this.submenuSelected) {
					this.menuToggle(); // if into submenu, close
					this.menuSelect(); // then return to parent
				} else {
					this.selectItem(this.selectedId - 1);
					this.menuToggle(); // if has submenu, show
				}
				preventDefault = true;
				break;

			case "Right":
			case "ArrowRight":
				if (this.isMobile) {
					if (!this.submenuSelected) {
						this.menuToggle(); // if has submenu, show
						this.menuSelect(); // then select first item
					}
				} else if (this.submenuSelected) {
					this.menuToggle(); // if into submenu, close
					this.menuSelect(); // then return to parent
				} else {
					this.selectItem(this.selectedId + 1);
					this.menuToggle(); // if has submenu, show
				}
				preventDefault = true;
				break;

			case "Home":
			case "PageUp":
				this.selectItem(0);
				break;

			case "End":
			case "PageDown":
				this.selectItem(-1);
				break;

			case "Tab":
				this.setInitialstate();
				break;

			default:
				break;
		}
		if (preventDefault) {
			event.stopPropagation();
			event.preventDefault();
		}
	}

	mobileToggle() {
		this.mobileWrapper.classList.toggle("active");
		this.mobileOverlay.classList.toggle("active");
		this.HTMLBody.classList.toggle("stop-scrolling");
		this.isMobile = !this.isMobile;
		if (this.isMobile) {
			// Wait transition end then focus the first el
			this.mobileWrapper.addEventListener("transitionend", () => this.selectItem(0), { once: true });
		} else {
			this.setInitialstate();
			this.toggleButton.focus();
		}
	}

	onPointerEvent(e) {
		if (this.isMobile && e.type === "mouseover") return;
		if (this.backButton.contains(e.target)) {
			this.selectedItem = e.target;
			this.menuToggle();
			return;
		}
		if (e.type === "mouseover") e.target.focus();
		const itemIndex = this.availableItems.findIndex((cItem) => cItem.isEqualNode(e.target));
		if (itemIndex >= 0) {
			this.selectedItem = e.target;
			this.selectedId = itemIndex;
			if (this.menuToggle()) {
				e.stopPropagation();
				e.preventDefault();
			}
		}
	}

	static isHidden(el) {
		return !el.offsetParent;
	}

	menuInit() {
		//  menu elements
		this.menuItems.push(...this.menu.querySelectorAll('[role="menuitem"]'));
		this.submenuItems.push(...this.menu.querySelectorAll('[aria-hasPopup = "true"]'));

		Array.from(this.menuItems).forEach((item) => {
			item.addEventListener("keydown", this.onKeydown.bind(this));
			item.addEventListener("click", this.onPointerEvent.bind(this));
			item.addEventListener("mouseover", this.onPointerEvent.bind(this));
		});

		this.backButton.addEventListener("click", this.onPointerEvent.bind(this));
		this.toggleButton.addEventListener("click", this.mobileToggle.bind(this));
		this.mobileOverlay.addEventListener("click", this.mobileToggle.bind(this));
		this.closeButton.addEventListener("click", this.mobileToggle.bind(this));

		this.component.addEventListener("mouseleave", this.setInitialstate.bind(this));
		window.addEventListener("resize", this.setInitialstate.bind(this));

		this.setInitialstate();
	}
}

// Initialize menubar editor
window.addEventListener("load", () => {
	const menuEl = document.getElementById("top-menu");
	if (menuEl && !window.isPoqMode) {
		const menu = new MenubarNavigation(menuEl);
		menu.menuInit();
	}
});
